export default __webpack_public_path__ + "static/media/search80737.a9de3efe.svg";